<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('touzijl')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>

		<div class="bet-record-container">
			<div class="cu-list menu-avatar" style="padding: 0px 5px;">
				<div v-for="(item, index) in list" :key="index" class="cu-item bg-gradual-black radius"
					style="margin-top: 5px; border-radius: 12px;">
					<div class="cu-avatar round lg margin-xs "
						:class="{ 'bg-gradual-black': item.name === 'USA', 'bg-gradual-blue': item.name === 'LDN', 'bg-gradual-orange': item.name === 'NASDAQ' }">
						<text class="avatar-text">
							<span>{{ (item.name) }}</span>
						</text>
					</div>
					<div class="content">
						<div class="text-yellow" style="font-size: 13px;">
							{{ formatTime(item.createtime) }}
							<div class="cu-tag round margin-left"
								:class="{  'bg-gradual-black':item.plan_name === 'VVIP','bg-gradual-blue': item.plan_name === '基础理财',  'bg-gradual-orange': item.plan_name === '资深理财', 'bg-gradual-red': item.plan_name === '专家理财',   'bg-gradual-purple': item.plan_name === '大师理财'  }">
								{{ $t(getPlanKey(item.plan_name)) }}
							</div>
						</div>
						<div class="text-sm flex">
							<div class="text-cut text-blue" style="font-size: 13px;">
								{{$t('lunm')}}：{{ item.issue }} - {{ $t(getnamen(item.play_method)) }}/{{ item.odds  }}
							</div>
						</div>
					</div>
					<div class="action" style="width: 100px;">
						<div class="cu-tag round bg-red" style="min-width: 80px; font-size: 16px;">
							-{{ item.quantity }}
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import userApi from "@/api/user";
	import time from "@/utils/time";
	export default {
		name: "BetRecord",
		components: {},
		data() {
			return {
				show: false,
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				statueList: ["全部", "未盈利", "已盈利", "已受理", "未受理", "已取消"],
				statueActive: 0,
				minDate: new Date(2018, 0, 1),
				maxDate: new Date(),
				currentDate: new Date(),
				begin_date: "",
				end_date: "",
				showTime: false,
			};
		},
		methods: {
			getnamen(playMethod) {
				const map = {
					'涨': '涨',
					'大涨': '大涨',
					'小涨': '小涨',
					'跌': '跌',
					'大跌': '大跌',
					'小跌': '小跌',
				}
				return map[playMethod] || playMethod
			},
			getPlanKey(planName) {
				const map = {
					'VVIP': 'chaoguibin',
					'基础理财': 'jichu',
					'资深理财': 'putong',
					'专家理财': 'guibin',
					'大师理财': 'zhuanye'
				}
				return map[planName] || planName
			},
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000)
				const month = (date.getMonth() + 1).toString().padStart(2, '0')
				const day = date.getDate().toString().padStart(2, '0')
				const year = date.getFullYear()
				const hours = date.getHours().toString().padStart(2, '0')
				const minutes = date.getMinutes().toString().padStart(2, '0')
				const seconds = date.getSeconds().toString().padStart(2, '0')
				return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`
			},
			timeStr(items) {
				return time.formatDatethree(items * 1000);
			},
			Reset() {
				this.statueActive = 0;
				this.begin_date = "";
				this.end_date = "";
			},
			BtnOk() {
				this.show = false;
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					duration: 0,
					forbidClick: true,
				});
				userApi
					.orderList(
						this.begin_date ? this.begin_date : this.formatDate(new Date()),
						this.end_date ? this.end_date : this.formatDate(new Date())
					)
					.then((data) => {
						// console.log(data, 4332)
						if (data.data.length) {
							this.list = data.data;
						} else {
							this.list = []
							this.$toast(this.$t('Tips.zanwu'));
						}
					});
				this.loading = false;
				this.finished = true;
				this.$toast.clear();
			},
			formatDate(date) {
				let yy = date.getFullYear();
				let mm = date.getMonth() + 1;
				mm = mm.toString();
				let dd = date.getDate().toString();
				return yy + "-" + mm.padStart(2, 0) + "-" + dd.padStart(2, 0);
			},
			changeTime(value) {
				console.log(this.formatDate(value));
				if (this.showTimeType == 0) {
					this.begin_date = this.formatDate(value);
				} else {
					this.end_date = this.formatDate(value);
				}
			},
			onRefresh() {
				this.refreshing = false;
				this.finished = false;
				this.loading = true;
				this.BtnOk();
			},
			changego() {
				this.$router.go(-1);
			},
			onLoad() {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
					this.BtnOk();
				}
			},
			changeDetail(item) {
				// 传详情iD
				this.$router.push({
					path: "/betDetail",
					query: {
						item: JSON.stringify(item)
					},
				});
			},
		},
		mounted() {
			this.onRefresh();
		},
	};
</script>

<style>
	.bg-gradual-purple {
		background-image: linear-gradient(45deg, #9000ff, #5e00ff);
		color: #fff;
	}

	.bg-gradual-red {
		background-image: linear-gradient(45deg, #f43f3b, #ec008c);
		color: #fff;
	}

	.bg-gradual-blue {
		background-image: linear-gradient(45deg, #0081ff, #1cbbb4);
		color: #fff;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.cu-list.menu-avatar {
		overflow: hidden;
	}

	.cu-list.menu-avatar>.cu-item {
		position: relative;
		display: flex;
		padding-right: 5px;
		height: 80px;
		background-color: #fff;
		justify-content: flex-end;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu-avatar>.cu-item>.cu-avatar {
		position: absolute;
		left: 17px;
	}

	.cu-avatar.lg {
		width: 55px;
		height: 55px;
		font-size: 2em;
	}

	.margin-xs {
		margin: 5px;
	}

	.cu-avatar {
		font-variant: small-caps;
		margin: 0;
		padding: 0;
		display: inline-flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		background-color: #ccc;
		color: #fff;
		white-space: nowrap;
		position: relative;
		width: 36px;
		height: 36px;
		background-size: cover;
		background-position: 50%;
		vertical-align: middle;
		font-size: 1.5em;
	}

	.cu-avatar .avatar-text {
		font-size: .4em;
	}

	.cu-list.menu-avatar>.cu-item .content {
		position: absolute;
		left: 83px;
		width: calc(100% - 55px - 34px - 68px - 11px);
		line-height: 1.6em;
	}

	.cu-list.menu-avatar>.cu-item .content>uni-view:first-child {
		font-size: 17px;
		display: flex;
		align-items: center;
	}

	.text-yellow,
	.line-yellow,
	.lines-yellow {
		color: #fbbd08;
	}

	.text-sm {
		font-size: 13px;
	}

	.bg-gradual-orange {
		background-image: linear-gradient(45deg, #ff9700, #ed1c24);
		color: #fff;
	}

	.cu-tag {
		font-size: 13px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 9px;
		height: 27px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.bg-red {
		background-color: #e54d42;
		color: #fff;
	}

	.round {
		border-radius: 2866px;
	}
</style>